@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.error-modal {
  width: 650px;
  border-top: 5px solid @inventory-allocation-error-modal--border-color;
  border-radius: 0 0 5px 5px;

  &.warning {
    border-top: 5px solid @inventory-allocation-error-modal--warning--border-color;

    .title-text {
      color: @inventory-allocation-error-modal--title--warning--text-color;
    }
  }
}

.error-modal-body {
  overflow-y: initial;
}

.title-row {
  display: flex;
}

.state-icon-wrapper {
  width: 40px;
  min-width: 40px;
  height: 40px;
}

.title-text {
  .truncate();
  line-height: 40px;
  font-size: 20px;
  color: @inventory-allocation-error-modal--title--text-color;
  width: 100%;
  max-width: 100%;
  padding: 0 10px;
}

.close-button-wrapper {
  width: 30px;
  height: 40px;
  min-width: 30px;
}

.message {
  margin-top: 15px;
  font-size: 14px;
  color: @inventory-allocation-error-modal--message--text-color;
}

.continue-button {
  margin-left: 10px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
}

.additional-items {
  font-size: 24px;
  text-align: center;
}

.error {
  padding: 15px;
}

.item-list {
  padding: 15px;
  background-color: @inventory-allocation-error-modal--list--background-color;

  > *:not(:first-child) {
    margin-top: 10px;
  }
}
